import React from 'react';
export var DeviationViewMode;
(function (DeviationViewMode) {
    DeviationViewMode["Theater"] = "theater";
    DeviationViewMode["Fullscreen"] = "fullscreen";
    DeviationViewMode["Normal"] = "regular";
})(DeviationViewMode || (DeviationViewMode = {}));
export var SessionContext = React.createContext({
    isLoggedIn: false,
});
SessionContext.displayName = 'SessionContext';
//# sourceMappingURL=SessionContext.js.map